import { render, staticRenderFns } from "./file_browser_drawer_toggle.vue?vue&type=template&id=57f88730&vue3"
import script from "./file_browser_drawer_toggle.vue?vue&type=script&lang=js&vue3"
export * from "./file_browser_drawer_toggle.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports